export default "__VITE_ASSET__BRwNqwJy__"